import { render, staticRenderFns } from "./ProductivityContentForCustomerService.vue?vue&type=template&id=4d09e4b8&"
import script from "./ProductivityContentForCustomerService.vue?vue&type=script&lang=js&"
export * from "./ProductivityContentForCustomerService.vue?vue&type=script&lang=js&"
import style0 from "./ProductivityContentForCustomerService.vue?vue&type=style&index=0&id=4d09e4b8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports